import { Outlet } from "react-router-dom";

import logo from '../img/swb-logo-heart.png'

function AuthLayout() {

  return (
    <div className="flex bg-slate-100 relative">
      {/* <Header /> */}
      <div
        className="relative flex mx-auto h-screen justify-center items-center w-3/4"
      >
        {/* Left */}
          <div className="flex flex-col items-center justify-center px-6 py-8 font-montserrat">
            <div className="w-full flex ml-40">
              <img src={logo} alt="School Wellbeing Logo" className="w-24 mb-10" />
            </div>
            <div
              className="w-full bg-white rounded-lg border shadow-lg dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700"
              style={{ maxWidth: 500, minHeight: 200 }}
            >
              <Outlet />
            </div>
          </div>
        {/* </main> */}
        {/* Right */}
      </div>
    </div>
  );
}

export default AuthLayout;
